export function applyNextCacheApiForVersion(content: string, nextMajorVersion: number): string {
  if (nextMajorVersion >= 16) {
    return content
  }

  return content
    .replace(
      /import \{ cacheLife, cacheTag \} from 'next\/cache'\n/g,
      "import { unstable_cacheTag as cacheTag } from 'next/cache'\n"
    )
    .replace(/\n {2}cacheLife\('max'\)/g, '')
    .replace(
      /import \{ updateTag \} from 'next\/cache'\n/g,
      "import { revalidateTag } from 'next/cache'\n"
    )
    .replace(/revalidateTag\(([^,\n]+), \{ expire: 0 \}\)/g, 'revalidateTag($1)')
    .replace(/\bupdateTag\(/g, 'revalidateTag(')
}
